import styled from '@emotion/styled';
import { ClipboardButton } from 'ts-components/ClipboardButton';

export const StyledTwoColumnsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  & > div {
    width: calc(50% - 10px);
  }
`;

export const StyledWebhookLabel = styled.span`
  display: flex;
  gap: 5px;
  font-size: inherit;
`;

export const StyledClipBoardButton = styled(ClipboardButton)`
  height: 14px;
  & button {
    height: 14px;
  }
`;

export const StyledRowPlaceholder = styled.div`
  height: 82px;
`;
